module.exports = __webpack_public_path__ + "files/b5f74eb4bd611a3ca87eba77c2a5edc1.png";